import React, { useEffect, useRef } from "react";
import { useMap, Marker, Popup } from "react-leaflet";
import L from "leaflet";

const LocationMarker = ({
  targetLocation,
  outsideClick,
  flyTo,
  suppressFly = false,
  locateRequestId = 0,
}) => {
  const map = useMap();
  const lastRequestRef = useRef(0);

  useEffect(() => {
    if (!targetLocation || !map || suppressFly) return;

    const isLocateRequest =
      locateRequestId > 0 && locateRequestId !== lastRequestRef.current;

    // User-initiated locate: immediately center + zoom (setView is not interrupted
    // by competing zoom updates the way an in-progress flyTo can be).
    if (isLocateRequest) {
      lastRequestRef.current = locateRequestId;
      map.setView(targetLocation, 13);
      return;
    }

    if (outsideClick) return;

    map.flyTo(targetLocation, flyTo ? 13 : 6, {
      duration: 2, // seconds (Leaflet uses seconds, not ms)
    });
  }, [targetLocation, map, outsideClick, flyTo, suppressFly, locateRequestId]);

  return (
    targetLocation &&
    flyTo && (
      <Marker
        position={targetLocation}
        icon={L.icon({
          iconSize: [25, 41],
          iconAnchor: [10, 41],
          popupAnchor: [2, -40],
          iconUrl: "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
          shadowUrl:
            "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
        })}
      >
        <Popup>You are here</Popup>
      </Marker>
    )
  );
};

export default LocationMarker;
